export default inputDate => {
	const date = new Date(inputDate);
	const locale = 'en-us';
	const month = date.toLocaleString(locale, { month: 'long' });
	const year = date.getFullYear();
	const dayOfMonth = date.getDate();
	return `${month} ${dayOfMonth}, ${year}`;
}
